import { DataTable, Table } from '@components'
import { toNumber } from '@helpers'
import { useCallback, useHistory, useMemo, useParams, useRequest, useTranslation } from '@hooks'
import { api, message } from '@services'
import { TFilteredRequest, TResponseWithFilters, TWardrobeItem, TShopifyOrder } from '@typings'
import * as React from 'react'
import { columns, wardrobeItemsColumns } from './UserViewOrders.tableOptions'

const UserViewOrdersTab: React.FC<TProps> = () => {
	// Main screen data.
	const { t } = useTranslation()
	const history = useHistory()
	const params = useParams<TParams>()
	const userId = toNumber(params?.id)
	const tableRef = React.useRef()

	// API data.
	const { data: { data: wardrobeItems, meta } = {}, fetch, fetching } = useRequest<
		TResponseWithFilters<TWardrobeItem[]>,
		TFilteredRequest & Partial<TWardrobeItem>
	>({
		request: (params) => api.getOrders({ ...params, userId }),
		onError: (error) => message.error(error.message),
	})

	return (
		<DataTable<TWardrobeItem, Partial<TWardrobeItem>>
			ref={tableRef}
			bordered
			loading={fetching}
			columns={columns}
			dataSource={wardrobeItems}
			meta={meta}
			onChange={fetch}
			expandable={{
				expandedRowRender: (record: TShopifyOrder) => (
					<Table
						key={record.id}
						rowKey="id"
						columns={wardrobeItemsColumns}
						dataSource={record.wardrobeItems}
						pagination={false}
					/>
				),
			}}
		/>
	)
}

type TProps = {
	/** */
}
type TParams = { id?: string }

export default UserViewOrdersTab
